import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import ThriftyAdviceWrapper from "@components/layouts/thriftyAdviceWrapper";
import style from "@components/thriftyadvice/privacy-policy/legal.module.scss";
export default function PrivacyPolicyHome(): ReactElement {
    return (
        <ThriftyAdviceWrapper>
            <PrivacyPolicy mainWrapperClassName={style["legal"]} />
        </ThriftyAdviceWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
